import { useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

const SingleCustomerContactsColumns = () => {
    // Define the breakpoints
    const isMobile = useMediaQuery('(max-width:600px)');

    return [
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell: ({ row }) => (
                <Link className="hive-grid-link-cell" to={`/contacts/${row._id}`} onClick={(event) => event.stopPropagation()}>
                    {row.name || [row.firstName, row.lastName].filter(Boolean).join(' ') || row.primaryEmail || 'View contact'}
                </Link>
            ),
          },
            // Conditionally show/hide columns
            ...(isMobile ? [] : [
                {
                    field: 'contactJobTitle',
                    headerName: "Job Title",
                    flex: 1
                },
                {
                    field: 'phoneNumber',
                    headerName: "Primary Phone",
                    flex: 1
                },
            ]),
            {
                field: "primaryEmail",
                headerName: "Email",
                flex: 1,
                renderCell: ({ row: { primaryEmail } }) => <a className="hive-grid-link-cell" href={`mailto:${primaryEmail}`}>{primaryEmail}</a>
            }
    ];
};

export default SingleCustomerContactsColumns
